import api from './api';

const deliveryChallanService = {
  getDeliveryChallans: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/delivery-challan?${queryString}`);
    return response.data;
  },

  getDeliveryChallanById: async (id) => {
    const response = await api.get(`/delivery-challan/${id}`);
    return response.data;
  },

  createDeliveryChallan: async (challanData) => {
    const response = await api.post('/delivery-challan', challanData);
    return response.data;
  },

  updateDeliveryChallan: async (id, challanData) => {
    const response = await api.put(`/delivery-challan/${id}`, challanData);
    return response.data;
  },

  deleteDeliveryChallan: async (id) => {
    const response = await api.delete(`/delivery-challan/${id}`);
    return response.data;
  },

  generatePDF: async (id) => {
    const response = await api.get(`/delivery-challan/${id}/pdf`, {
      responseType: 'blob'
    });
    return response.data;
  }
};

export default deliveryChallanService;